<template>
  <b-sidebar id="sidebar-1" title="" shadow backdrop>
    <template #default="{ hide }">
      <div>
        <!--  -->
        <div class="WorkM_SideMenuGroup">
          <div class="WorkM_SideMenuGroup__Title">機能</div>
          <div class="WorkM_SideMenuGroup__ButtonArea">
            <b-row>
              <b-col cols="6">
                <div class="WorkM_Button WorkM_LinkButton" @click="hide();clickLinkButton('/Home');">ホーム</div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="WorkM_Button WorkM_LinkButton" @click="hide();clickLinkButton('/WorkRegist')">報告</div>
              </b-col>
              <b-col cols="6">
                <div class="WorkM_Button WorkM_LinkButton" @click="hide();clickLinkButton('/WorkCalendar')">カレンダー</div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="WorkM_Button WorkM_LinkButton" @click="hide();clickLinkButton('/ApplicationRegist')">事前申請</div>
              </b-col>
              <b-col cols="6">
                <div v-if="(systemAuthorityType == null || systemAuthorityType == 0)" class="WorkM_Button WorkM_LinkButton WorkM_LinkButton_Disabled">承認</div>
                <div v-else class="WorkM_Button WorkM_LinkButton" @click="hide();clickLinkButton('/Approval')">承認</div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="WorkM_Button WorkM_LinkButton" @click="hide();clickLinkButton('/ApplicationHistory')">承認状況</div>
              </b-col>
              <b-col cols="6">
                <div v-if="(systemAuthorityType == null || systemAuthorityType == 0)" class="WorkM_Button WorkM_LinkButton WorkM_LinkButton_Disabled">承認履歴</div>
                <div v-else class="WorkM_Button WorkM_LinkButton" @click="hide();clickLinkButton('/ApprovalHistory')">承認履歴</div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div class="WorkM_Button WorkM_LinkButton" @click="hide();clickLinkButton('/AttendanceCheck')">在席一覧</div>
              </b-col>
              <b-col cols="6">
                <div class="WorkM_Button WorkM_LinkButton" @click="hide();clickLinkButton('/WorkState')">勤務状況</div>
              </b-col>
            </b-row>
          </div>
        </div>
        <!-- その他 -->
        <div class="WorkM_SideMenuGroup">
          <div class="WorkM_SideMenuGroup__Title">その他</div>
          <div class="WorkM_SideMenuGroup__ButtonArea">
            <b-row>
              <b-col cols="6">
                <div class="WorkM_Button WorkM_LinkButton" @click="hide();clickPasswordChange()">ﾊﾟｽﾜｰﾄﾞ変更</div>
              </b-col>
              <b-col cols="6">
                <div class="WorkM_Button WorkM_LinkButton" @click="hide();clickLogout()">ログアウト</div>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="text-muted text-center mt-2 system-version">{{ systemVersion }}</div>
        <ChangeLoginPasswordModalVue ref="changeLoginPasswordModal"></ChangeLoginPasswordModalVue>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable */
import config from "../../const/config";
import ChangeLoginPasswordModalVue from "../SystemUser/ChangeLoginPasswordModal.vue";
import BtnLogout from "../BaseLayout/BtnLogout.vue";

export default {
  name: "SideMenu",
  components: { ChangeLoginPasswordModalVue, BtnLogout },
  props: {
    systemVersion: {type:  String, default: ""},
  },
  data: function () {
    return {
      targetContractCode: null,
      targetCorpCode: null,
      systemAuthorityType: 0,
      btnSideMenuVariant: "outline-secondary",
    };
  },
  computed: {
    isUserCharger: function () {
      return this.$store.getters.isUserCharger;
    },
  },
  mounted: function () {
    this.targetContractCode = this.$store.getters.getContractCode;
    this.targetCorpCode = this.$store.getters.getCorpCode;
    this.systemAuthorityType = this.$store.state.system_authority_type;
    console.debug("systemAuthorityType：" + this.systemAuthorityType);
  },
  methods: {
    clickLinkButton: function (path) {
      this.$router.push(path);
    },
    toMyNumberPage: function () {
      if (this.$route.path == "/MstMyNumber") {
        return;
      }
      this.$refs.myNumberPasswordModal.openModal();
    },

    // パスワードチェック
    checkAuthMyNumber: function (pw) {
      let reqestBody = {
        my_number_pw: pw,
      };

      this.putDataMultiKey(
        config.URL.MST_MY_NUMBER_LOGIN + config.PROCESS.LOGIN,
        reqestBody,
        this.targetContractCode,
        this.targetCorpCode
      )
        .then((response) => {
          if (response.result) {
            if (response.container) {
              this.$refs.myNumberPasswordModal.closeModal();
              this.$router.push("/MstMyNumber");
            } else {
              this.showAlertError("パスワードが正しくありません。");
            }
          } else {
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          this.showToastServerError(e);
        });
    },
    //
    clickPasswordChange: function () {
      this.$refs.changeLoginPasswordModal.openModal();
    },
    downloadWorkTemplate: function () {
      this.getDataMultiKey("/api/get_url/kinmu_template")
        .then((response) => {
          if (response.result) {
            //正常
            window.open(response.container, "_blank");
          } else {
            //エラー発生
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {});
    },
    // BtnLogout.vueを基に実装
    clickLogout: function(){
      //状態をログアウトとする
      let message = "ログアウトします。<br>よろしいですか？";
      this.$confirm(message, "確認", {
        confirmButtonText: "OK",
        cancelButtonText: "キャンセル",
        dangerouslyUseHTMLString: true,
        customClass:"editCheckModalWidthHeader"
      }).then(() => {
        this.logout();
      });
    },
    logout: function () {
      this.postData(config.URL.LOGOUT)
        .then((respons) => {
          console.log(respons);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.$router.push(config.PAGES.LOGIN);
        });
    }
  },
};
</script>

<style>
.WorkM_SideMenuGroup {
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 15px;
}
.WorkM_SideMenuGroup__Title {
  padding: 0.5rem;
  font-size: 0.85rem;
  padding-left: 10px;
  text-align: left;
  background: var(--mainColor);
  border-radius: 10px 0 0 0;
  color: white;
}
.WorkM_SideMenuGroup__ButtonArea {
  padding: 0.5rem 0;
}

.WorkM_LinkButton {
  font-size: 0.85rem;
  border: 1px solid rgb(138, 135, 135);
}

.WorkM_LinkButton_Disabled{
  background-color: rgba(0,0,0,0.1);
}

.system-version {
  font-size: 13px;
  position: absolute;
  bottom: 1.5em;
  width: 100%;
}
</style>
